import { Card, CardBody, CardTitle, Table } from "reactstrap";
import PropTypes from "prop-types";
import { ReactComponent as FileIcon } from "feather-icons/dist/icons/file-text.svg";

const DocumentsTable = ({title, tableData}) => {
  return (
    <div>
      <Card style={{ boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.05)', marginBottom: '30px' }}>
        <CardBody>
          <CardTitle tag="h5">{title}</CardTitle>

          <Table className="no-wrap mt-3 align-middle" responsive borderless size="sm">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Revisión</th>
                <th>Ver</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((tdata, index) => (
                <tr key={`${tdata.name}-${index}`} className="border-top">
                  <td>
                    <div className="d-flex align-items-center p-0">
                      <div className="ms-3">                        
                        <span className="text-muted">{tdata.name}</span>
                      </div>
                    </div>
                  </td>
                  <td>{tdata.updatedDate}</td>
                  <td><a href={tdata.file} target="_blank" rel="noopener noreferrer" style={{textDecoration: "underline", color: "blue"}}><FileIcon /></a></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

DocumentsTable.propTypes = {
  title: PropTypes.string.isRequired,
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      updatedDate: PropTypes.string.isRequired,
      file: PropTypes.string.isRequired
    })
  ).isRequired
};

export default DocumentsTable;
